/*
 * @Descripttion: main.js
 * @version: 1.0.0
 * @Author: Jiang ShareFont
 * @Date: 2023-03-15 15:24:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-05-18 17:47:35
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueDragResize from 'vue-drag-resize'
import { setCookie, getCookie, delCookie } from './common/js/cookie.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.prototype.$cookie = { setCookie, getCookie, delCookie }
Vue.component('vue-drag-resize', VueDragResize)
Vue.config.productionTip = false
Vue.use(ElementUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js